export default __webpack_public_path__ + "static/media/Astro_Venus_White.1937b881.png";